// validation schema
export const validate = (name, value, currentErrorObj, businessType) => {
  console.log("validate", [businessType, name, value]);
  const err = { ...currentErrorObj };
  // switch (name) {
  //     case 'floorLoadCapacity':
  //     case 'accessPoints':
  //     case 'loadingDocks':
  //     case 'clearanceHeight':
  //     case 'permissibleUses':
  //     case 'leaseOptions':
  //         if (businessType !== '9') {
  //             err[name] = ''; // Agar businessType warehouse nahi hai to validation hata do
  //             return err;a
  //         }
  //         break;
  // }
  switch (name) {
    case "city":
      if (value === "") {
        err.city = `City is required`;
      } else {
        // in case of no error all OK
        err.city = "";
      }
      return err;
    case "cityId":
      if (value === "") {
        err.cityId = `City is required`;
      } else {
        // in case of no error all OK
        err.cityId = "";
      }
      return err;

    case "state":
      if (value === "") {
        err.state = `State is required`;
      } else {
        err.state = "";
      }
      return err;
    case "stateId":
      if (value === "") {
        err.stateId = `State is required`;
      } else {
        err.stateId = "";
      }
      return err;
    case "stateCode":
      if (value === "") {
        err.stateCode = `State is required`;
      } else {
        err.stateCode = "";
      }
      return err;
    case "customerName":
      if (value === "") {
        err.customerName = `Full name is required`;
      } else {
        err.customerName = "";
      }
      return err;

    case "addressOne":
      if (value === "" || !value) {
        err.addressOne = "Street address is required";
      } else {
        err.addressOne = "";
      }
      return err;
    case "address":
      if (value === "" || !value) {
        err.address = "Street address is required";
      } else {
        err.address = "";
      }
      return err;
    case "fullName":
      if (value === "" || !value) {
        err.fullName = "Taxpayer or business name is required";
      } else {
        err.fullName = "";
      }
      return err;
    case "businessEntityName":
      if (value === "" || !value) {
        err.businessEntityName = "Disregarded entity name is required";
      } else {
        err.businessEntityName = "";
      }
      return err;
    case "taxClassificationId":
      if (value === "" || !value) {
        err.taxClassificationId = "Tax classification is required";
      } else {
        err.taxClassificationId = "";
      }
      return err;
    case "signDate":
      if (value === "" || !value) {
        err.signDate = "Sign date is required";
      } else {
        err.signDate = "";
      }
      return err;
    case "signature":
      if (value === "" || !value) {
        err.signature = "Your signature is required";
      } else {
        err.signature = "";
      }
      return err;
    case "usTaxIdNumber":
      if (value === "" || !value) {
        err.usTaxIdNumber = "US tax ID number (SSN/EIN) is required";
      } else {
        err.usTaxIdNumber = "";
      }
      return err;

    case "zipCode":
      // eslint-disable-next-line no-case-declarations
      const regex = /^[0-9]*$/;
      if (value === "") {
        err.zipCode = "Zip code is required";
      } else if (!regex.test(value)) {
        err.zipCode = "Zip Code must be a number";
      } else {
        err.zipCode = "";
      }
      return err;
    case "zipcode":
      // eslint-disable-next-line no-case-declarations
      const regexZipcode = /^[0-9]*$/;
      if (value === "") {
        err.zipcode = "Zip code is required";
      } else if (!regexZipcode.test(value)) {
        err.zipcode = "Zip Code must be a number";
      } else {
        err.zipcode = "";
      }
      return err;

    case "storageTypeId":
      if (value === "") {
        err.storageTypeId = "Listing type is required";
      } else {
        err.storageTypeId = "";
      }
      return err;
    case "quantity":
      if (value === "") {
        err.quantity = "quantity type is required";
      } else {
        err.quantity = "";
      }
      return err;
    case "spaceLength":
      if (businessType !== "9" && value === "") {
        err.spaceLength = "Space length is required";
      } else if (value && Number(value) <= 0) {
        err.spaceLength = "Space length cannot be negative or zero";
      } else if (value && Number(value) > 500) {
        err.spaceLength = "Space length cannot be greater than 500";
      } else {
        err.spaceLength = "";
      }
      return err;
    case "spaceWidth":
      if (businessType !== "9" && value === "") {
        err.spaceWidth = "Space width is required";
      } else if (value && Number(value) <= 0) {
        err.spaceWidth = "Space width cannot be negative or zero";
      } else if (value && Number(value) > 500) {
        err.spaceWidth = "Space width cannot be greater than 500";
      } else {
        err.spaceWidth = "";
      }
      return err;
    case "spaceHeight":
      if (businessType !== "9" && value === "") {
        err.spaceHeight = "Space height is required";
      } else if (value && Number(value) <= 0) {
        err.spaceHeight = "Space height cannot be negative or zero";
      } else if (value && Number(value) > 100) {
        err.spaceHeight = "Space height cannot be greater than 100";
      } else {
        err.spaceHeight = "";
      }
      return err;
    case "title":
      if (value === "") {
        err.title = "Listing title is required";
      } else if (value?.length > 100) {
        err.title =
          "Listing title must be less than or equal to 100 characters";
      } else {
        err.title = "";
      }
      return err;
    case "description":
      if (value === "") {
        err.description = "Listing description is required";
      // } else if (value?.length > 1000) {
      //   err.description =
      //     "Listing title must be less than or equal to 1000 characters";
      // }
      } else {
        err.description = "";
      }
      return err;

    case "accessDetails":
      if (value && value?.length < 500) {
        err.accessDetails =
          "Access details must be less greater or equal to 500 characters";
      } else {
        err.accessDetails = "";
      }
      return err;
    case "spaceAmenities":
      if (!value.some((element) => element.isChecked)) {
        err.spaceAmenities = "Please atleast select one amenity";
      } else {
        err.spaceAmenities = "";
      }
      return err;

    case "propertyType":
      if (value === "") {
        err.propertyType = "Property type is required";
      } else {
        err.propertyType = "";
      }
      return err;
    // case 'accessFrequency':
    //   if (value === '' || !value) {
    //     err.accessFrequency = 'Access frequency is required';
    //   } else {
    //     err.accessFrequency = '';
    //   }
    //   return err;

    case "rate":
      if (!value?.monthlyRate && !value?.dailyRate && !value.weeklyRate) {
        err.rate = "Rate is required";
      } else {
        err.rate = "";
      }

      if (value.monthlyRate !== "") {
        if (Number(value.monthlyRate) <= 0) {
          err.rate = "Monthly rate must be greater than or equal to 1";
        }
      }

      if (value.dailyRate !== "") {
        if (Number(value.dailyRate) <= 0) {
          err.rate = "dailyRate rate must be greater than or equal to 1";
        }
      }

      if (value.weeklyRate !== "") {
        if (Number(value.weeklyRate) <= 0) {
          err.rate = "Weekly rate must be greater than or equal to 1";
        }
      }

      return err;

    // case 'rate':
    //     if (value.weeklyRate === '' && value.monthlyRate === '') {
    //         err.rate = 'Weekly or monthly rate is required';
    //     } else if (Number(value.weeklyRate) < 0 && Number(value.monthlyRate) < 0) {
    //         err.rate = 'Weekly or monthly rate cannot be negative';
    //     } else if (Number(value.weeklyRate) < 0) {
    //         err.rate = 'Weekly rate cannot be negative';
    //     } else if (Number(value.monthlyRate) < 0) {
    //         err.rate = 'Monthly rate cannot be negative';
    //     } else if (value.monthlyRate === '' && !Number(value?.weeklyRate)) {
    //         err.rate = 'Weekly rate must be greater than or equal to 1';
    //     } else if (value.weeklyRate === '' && !Number(value?.monthlyRate)) {
    //         err.rate = 'Monthly rate must be greater than or equal to 1';
    //     } else if (!Number(value?.weeklyRate) && !Number(value?.monthlyRate)) {
    //         err.rate = 'Weekly or monthly rate must be greater than or equal to 1';
    //     } else {
    //         err.rate = '';
    //     }
    //     return err;

    // case 'monthlyRate':
    //     if (value === '') {
    //         err.rate = 'Monthly and weekly rate is required';
    //     } else if (Number(value) < 0) {
    //         err.rate = 'Monthly and weekly rate cannot be negative';
    //     } else if (!Number(value)) {
    //         err.rate = 'Monthly and weekly rate must be greater than or equal to 1';
    //     } else {
    //         err.rate = '';
    //     }
    //     return err;
    // case 'weeklyRate':
    //     if (value === '') {
    //         err.rate = 'Monthly and weekly rate is required';
    //     } else if (Number(value) < 0) {
    //         err.rate = 'Monthly and weekly rate cannot be negative';
    //     } else if (!Number(value)) {
    //         err.rate = 'Monthly and weekly rate must be greater than or equal to 1';
    //     } else {
    //         err.rate = '';
    //     }
    //     return err;
    case "approvalOnVisit":
      if (!value || value === null) {
        err.approvalOnVisit = "Approval on visit is required";
      } else {
        err.approvalOnVisit = "";
      }
      return err;
    case "isPermissionAgreed":
      if (!value) {
        err.isPermissionAgreed = "Please agree to terms and conditions";
      } else {
        err.isPermissionAgreed = "";
      }
      return err;

    case "floorLoadCapacity":
      if (!value || isNaN(value) || Number(value) <= 0) {
        err.floorLoadCapacity = "Floor Load Capacity must be a positive number";
      } else {
        err.floorLoadCapacity = "";
      }
      return err;

    case "accessPoints":
      if (!value || value.trim() === "") {
        err.accessPoints = "Access Points description is required";
      } else {
        err.accessPoints = "";
      }
      return err;

    case "loadingDocks":
      if (!value || isNaN(value) || Number(value) < 0) {
        err.loadingDocks =
          "Number of Loading Docks must be a non-negative number";
      } else {
        err.loadingDocks = "";
      }
      return err;

    case "clearanceHeight":
      if (!value || isNaN(value) || Number(value) <= 0) {
        err.clearanceHeight = "Clearance Height must be a positive number";
      } else {
        err.clearanceHeight = "";
      }
      return err;

    case "permissibleUses":
      if (!value || value.trim() === "") {
        err.permissibleUses = "Permissible Uses description is required";
      } else {
        err.permissibleUses = "";
      }
      return err;

    case "leaseOptions":
      if (!value || value.trim() === "") {
        err.leaseOptions = "Lease Options selection is required";
      } else if (
        ![
          "Short-Term (1-6 months)",
          "Medium-Term (6-12 months)",
          "Long-Term (1+ years)",
          "Flexible",
        ].includes(value)
      ) {
        err.leaseOptions = "Invalid Lease Option selected";
      } else {
        err.leaseOptions = "";
      }
      return err;

    default:
      break;
  }
};
